import { Injectable } from '@angular/core';
import { CountlyService, CmxAuthProfile } from '@cemex-core/angular-services-v8';
import { environment } from '../../../../../environments/environment';
import { UserCountly } from '../models/user-countly.interface';
import { AppState, getAppState } from '@cemex/cmx-client-layout';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';

/**
 * This is a wrapper around the official CountlyService from the cemexcomponents repo
 * It should provide a clearer way of initializing Countly without worrying for
 * method call order as in the docs: https://cemexpmo.atlassian.net/wiki/spaces/SDTS/pages/21926416/Web+Countly+implementation
 * This service is for initialization only, otherwise the use the CountlyService from the '@cemex-core/helpers-v1/dist' repo
 * please.
 */
@Injectable()
export class CustomCountlyService {
  userInfo: UserCountly = {};
  constructor(
    private countlyService: CountlyService,
    private store: Store<State>,
  ) {}

  initialize(userProfile: CmxAuthProfile): void {
    this.countlyService.startService(environment.countlyUrl, environment.countlyKey);
    this.userInfo.UserId = String(userProfile.customerId);
    this.userInfo.UserEmail = userProfile.userAccount;
    this.countlyService.identifyUser(this.userInfo);
    this.countlyService.addTracking('track_sessions');
    this.countlyService.init();
  }

  /**
   * Creates a user using the logged in user's data (taken from the state)
   * returns an Observable containing a UserCountly object
   */
  public getUserInfo(): Observable<UserCountly> {
    return this.store.select(getAppState).pipe(
      first((state): boolean => !!state && !!state.auth && !!state.auth.profile),
      map((state: AppState) => state.auth.profile),
      map((profile) => {
        this.userInfo.UserId = String(profile.customerId);
        this.userInfo.UserEmail = profile.userAccount;
        return this.userInfo;
      }),
    );
  }
  /**
   * Adds an event
   * page: string. The name of the page to log
   * userInfo: UserCountly. The user logging the event
   */
  public addEvent(page: string, userInfo: UserCountly) {
    if (page && userInfo) {
      this.countlyService.addTracking('add_event', {
        key: page,
        count: 1,
        segmentation: userInfo,
      });
    }
  }
}
